import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Search, Loader2 } from "lucide-react";
import api from "@/lib/api";
import { fullName, TEMPERATURES } from "@/lib/crm";

export default function GlobalSearch() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const boxRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    setLoading(true);
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/search`, { params: { q } });
        setResults(data);
        setOpen(true);
      } catch {}
      setLoading(false);
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  const go = (id) => {
    setOpen(false); setQ("");
    navigate(`/leads/${id}`);
  };

  return (
    <div className="relative w-full max-w-md" ref={boxRef}>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        {loading && <Loader2 className="absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 animate-spin text-muted-foreground" />}
        <input
          data-testid="global-search-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onFocus={() => results.length && setOpen(true)}
          placeholder="Cerca lead per nome, telefono, email o nelle note…"
          className="w-full h-9 pl-9 pr-9 rounded-md bg-muted/60 border border-transparent focus:border-ring focus:bg-background text-sm outline-none transition-colors"
        />
      </div>
      {open && results.length > 0 && (
        <div className="absolute z-50 mt-1 w-full bg-popover border rounded-md shadow-lg overflow-hidden">
          {results.map((l) => {
            const t = TEMPERATURES[l.temperature] || TEMPERATURES.poco_caldo;
            return (
              <button
                key={l.id}
                data-testid={`search-result-${l.id}`}
                onClick={() => go(l.id)}
                className="w-full flex items-center gap-3 px-3 py-2 hover:bg-accent text-left transition-colors"
              >
                <span className={`w-2 h-2 rounded-full ${t.dot}`} />
                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium">{fullName(l)}</span>
                  {l.matched_note && <span className="block text-xs text-muted-foreground truncate" data-testid={`search-note-match-${l.id}`}>Nota: {l.matched_note}</span>}
                </span>
                <span className="text-xs text-muted-foreground">{l.company}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
